import { put, select, spawn, takeLatest } from 'redux-saga/effects';
import { languageConfigType } from './language.types';
import { languageActions, languageSelectors, languageTypes } from '../language';
import i18n from 'i18next';
import { deepReplaceKeys } from '../../helper/DataHelper';
import { migrateLegacyPluralKeys, toResourceLanguageCode } from '../../i18n/languageCode';
import { readBrowserLanguages, readSelectedLanguage, resolveStartLanguage, storeSelectedLanguage } from './startLanguage';

export function* setDefaultLanguageSaga() {
    const languageConfig: languageConfigType = yield select(languageSelectors.getLanguageConfig);
    yield put(languageActions.changeLanguage(resolveStartLanguage(languageConfig, readBrowserLanguages(), readSelectedLanguage())));
}

export function* selectLanguageSaga({ payload }: { payload: string; type: string }) {
    storeSelectedLanguage(payload);
    yield put(languageActions.changeLanguage(payload));
}

function* mergeCustomTranslationsSaga() {
    const languageConfig: languageConfigType = yield select(languageSelectors.getLanguageConfig);

    let merged = false;
    for (const value in languageConfig.translations) {
        const translations = migrateLegacyPluralKeys(deepReplaceKeys(languageConfig.translations[value], '.') ?? {});

        const languageCode = toResourceLanguageCode(value);
        i18n.addResourceBundle(languageCode, 'envago', translations, true, true);
        merged = i18n.hasResourceBundle(languageCode, 'envago');
    }
    yield put(languageActions.mergeTranslationsDone(merged));
}

function* changeLanguageSaga({ payload, type }: { payload: string; type: string }) {
    yield i18n.changeLanguage(payload);
    yield put(languageActions.changeLanguageDone(payload));
}

export default function* languageSaga() {
    yield takeLatest(languageTypes.CHANGE_LANGUAGE, changeLanguageSaga);
    yield takeLatest(languageTypes.SELECT_LANGUAGE, selectLanguageSaga);
    yield spawn(setDefaultLanguageSaga);
    yield spawn(mergeCustomTranslationsSaga);
}
